import styled from 'styled-components';
import { Modal, Icon, Header, Image, Input, Button } from 'semantic-ui-react';

export const ModalContainer = styled(Modal)`
  max-width: 400px;
`;

export const CloseIcon = styled(Icon)`
  color: #000 !important;
  margin: 10px;
  right: 0px !important;
  top: 0px !important;
`;

export const ModalContent = styled(Modal.Content)`
  background-color: #f6f3f3 !important;
  border-radius: 0px !important;
  color: #000;
  font-family: 'Neutraface';
  font-size: 18px;
  padding: 50px 50px 30px 50px !important;
  text-align: center;

  input {
    border: 0.5px solid #000 !important;
  }
  @media only screen and (max-width: 767px) {
    &&&& {
      padding: 50px !important;
    }
  }
`;

/* Image modal components */
/* ============================= */

export const SocialInput = styled(Input)`
  width: 100%;
  input {
    border-radius: 0px !important;
  }

  @media only screen and (max-width: 767px) {
    input {
      width: 50% !important;
    }
  }

  button {
    background-color: ${(props) => props.customcolor} !important;
    border-radius: 0px !important;
  }

  i {
    color: #fff;
  }

  .label {
    background-color: transparent !important;
    color: #000 !important;
    font-family: 'OpenSansSemiBold';
    padding-left: 0px !important;
  }
`;
export const CopyButton = styled(Button)`
  background-color: ${(props) => props.customcolor} !important;
  border-bottom: 1px dotted black;
  display: inline-block;
  position: relative;

  span {
    background-color: #fff;
    border: 1px solid rgba(34, 36, 38, 0.15);
    border-radius: 6px;
    color: rgba(34, 36, 38, 0.85);
    left: 50%;
    margin-left: -60px;
    padding: 5px 0;
    position: absolute;

    /* Position the tooltip */
    text-align: center;
    top: 140%;
    visibility: hidden;
    width: 150px;
    width: 120px;
    z-index: 1;
  }

  &:hover span {
    visibility: visible;
  }
`;

export const SocialButtons = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  outline-style: none !important;

  .SocialMediaShareButton {
    margin: 20px 10px 0 10px;

    div {
      &:hover {
        cursor: pointer;
      }
    }
  }
`;
